import { ContentType, IPictureFileMetadataResponse } from '@kcftech/prometheus-client';

export class PrintableError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'PrintableError';
    }
}

/**
 * Payload object for a file upload.
 */
export type FileUpload = File;

export type DeleteFileText = Readonly<{
    actionText: string;
    checkText: string;
}>;

export const getDeleteFileModalText = (
    rowData: Pick<IPictureFileMetadataResponse, 'FileType' | 'FolderCount' | 'FileCount'>,
): DeleteFileText => {
    if (rowData.FileType === ContentType.Folder) {
        return {
            actionText: `delete this folder? It contains ${
                rowData.FolderCount ?? 0
            } folders and ${
                rowData.FileCount ?? 0
            } files. The data will no longer be available.`,
            checkText: 'delete this folder and all its contents',
        };
    }

    return {
        actionText: 'delete this file? The data will no longer be available.',
        checkText: 'delete this file and its data',
    };
};

/**
 * Regex for excluding special characters from folder name.
 */
export const excludeSpecialChars = /^[^:<>"/\\|?*]*$/;
